import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { finishLoad, initLoad } from '../../..';
import { IListSlice } from '../../../types';
import filterEntities from './filterEntities';

export default function addEntitiesMonitorActions(
  builder: ActionReducerMapBuilder<IListSlice>,
) {
  builder.addCase(filterEntities.pending, (state, payload) => {
    initLoad(state, payload.meta.arg.listId);
  });
  builder.addCase(filterEntities.rejected, (_, payload) => {
    console.error(payload.error);
  });
  builder.addCase(filterEntities.fulfilled, (state, { payload, meta }) => {
    console.log(payload.filters);

    state.lists[meta.arg.listId].filters = payload.filters;
    state.lists[meta.arg.listId].rows = payload.rows;
    state.lists[meta.arg.listId].pageInfo = payload.pageInfo;
    if (payload.customLabel) {
      state.lists[meta.arg.listId].customLabel = payload.customLabel;
    }

    finishLoad(state, meta.arg.listId, true, payload.filters);
  });
}
